import React from 'react';

import { Controller, useForm } from 'react-hook-form';

import InputAdornment from '@material-ui/core/InputAdornment';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { Typography, Box } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';

import { SearchContainer } from './InventoryAnalystSearch.styles';
import { ProviderSearchByGeographyV2 } from './ProviderSearchByGeographyV2';

import { ButtonV2 } from '../../../components/common/v2/ButtonV2/ButtonV2';
import {
  TextFieldProviderLocationsV2,
  TextFieldV2,
} from '../../../components/common/v2/TextInputV2/TextInputV2';
import { sortAlphabeticalStrings } from '../../../components/Utils/Utils';

export const InventoryAnalystSearchV2 = ({
  filtersResetKey,
  finalData,
  formattedaddressVal,
  handleClearFA,
  handleFormattedAddressChange,
  handleKeyDown,
  handleMouseEnterFA,
  handleMouseLeaveFA,
  handleSelectData,
  isHoveredFA,
  majorProvidersList,
  searchProviderLocations,
  searchProviders,
  handleGeographySearchClear,
  isAnyValueSelected,
}) => {
  const { control } = useForm({
    defaultValues: {
      provider: '',
      emailid: '',
      address: '',
      formattedaddress: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
      lat: '',
      long: '',
      region: '',
      currency: '',
      price: '',
      selectedDate: '',
      amneties: '',
    },
    mode: 'onChange',
  });

  return (
    <SearchContainer>
      <Box>
        <Typography sx={{ fontSize: '14px', color: '#596668', fontFamily: 'Calibre-R' }}>
          Filter By Provider
        </Typography>
        <Controller
          style={{ marginBottom: '20px' }}
          name="provider"
          control={control}
          render={() => (
            <Autocomplete
              key={filtersResetKey}
              freeSolo
              options={
                majorProvidersList?.length > 0
                  ? sortAlphabeticalStrings('providerName', majorProvidersList)
                  : []
              }
              getOptionLabel={(option) =>
                typeof option === 'object' ? option.providerName : option
              }
              renderInput={(params) => (
                <TextFieldProviderLocationsV2
                  {...params}
                  variant="outlined"
                  fullWidth
                  style={{ fontSize: '20px', color: '#1a1a1a', padding: 0 }}
                  label=""
                  placeholder="Select Provider"
                  onBlur={handleKeyDown}
                  InputProps={{ ...params.InputProps }}
                />
              )}
              ListboxProps={{ style: { maxHeight: '450px' } }}
              onChange={(_, data) => {
                if (data) {
                  searchProviders(data.providerName, 'dropdown');
                }
              }}
            />
          )}
        />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '14px', color: '#596668', fontFamily: 'Calibre-R' }}>
          Filter By Address
        </Typography>
        <Controller
          name="formattedaddress"
          control={control}
          render={({ field }) => (
            <TextFieldProviderLocationsV2
              {...field}
              variant="outlined"
              fullWidth
              value={formattedaddressVal}
              placeholder="Formatted Address"
              onMouseEnter={handleMouseEnterFA}
              onMouseLeave={handleMouseLeaveFA}
              onChange={handleFormattedAddressChange}
              InputProps={{
                endAdornment: formattedaddressVal && isHoveredFA && (
                  <InputAdornment position="end">
                    <IconButton title="Clear" onClick={handleClearFA}>
                      <ClearRoundedIcon style={{ color: '#1a1a1a' }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                shrink: (field.value !== '' && field.value !== null) || field.onFocus,
              }}
            />
          )}
        ></Controller>
      </Box>
      <Box sx={{ overflow: 'hidden', minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '14px',
            color: '#596668',
            fontFamily: 'Calibre-R',
            whiteSpace: 'nowrap',
          }}
        >
          Filter By Geography
        </Typography>

        <Box
          sx={{
            width: '100%',
            minWidth: 0,
            position: 'relative',
            overflow: 'visible',
          }}
        >
          <ProviderSearchByGeographyV2
            selectedData={finalData}
            onSelectData={handleSelectData}
            handleGeographySearchClear={handleGeographySearchClear}
          />
        </Box>
      </Box>
      <ButtonV2
        onClick={searchProviderLocations}
        variant="contained"
        sx={{
          marginTop: '21px',
          width: '100%',
          minWidth: '120px',
          padding: '29px 16px',
          fontFamily: 'Calibre-R',
          whiteSpace: 'nowrap',
        }}
        disabled={!isAnyValueSelected}
      >
        Apply Filters
      </ButtonV2>
    </SearchContainer>
  );
};
